import { render } from "./Contracts.vue?vue&type=template&id=ca48f656&ts=true"
import script from "./Contracts.vue?vue&type=script&lang=ts"
export * from "./Contracts.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/zpp/var/code/p-kunden.nsl.software/node-kunden-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__